module.exports = __webpack_public_path__ + "static/media/ncbr.f8491c30.svg";